import React, { ReactNode, useEffect, useState } from 'react';
import { EpDropdown } from '../EpDropdown';
import { EpIcon } from '../EpIcon';
// TODO: rever configuração do build do epico-types e rever utilização de enum
import {
  IColors,
  ColorsEnum,
  IEpDropdownDefaultListItems,
} from '../../interfaces';

import './EpAvatar.scss';

interface EpAvatarProps {
  avatarId: string;
  dropdownId?: string;
  avatarContent: 'text' | 'icon';
  avatarSize?: 'sm' | 'md' | 'lg' | '2xl';
  avatarIconName?: string;
  avatarIconImgSrc?: string;
  avatarIconImgAlt?: string;
  userName?: string;
  avatarHasDropdown?: boolean;
  dropdownDefaultList?: IEpDropdownDefaultListItems[];
  customClasses?: string;
  dropdownMenuPlacement?: 'left' | 'right';
  avatarBgColor?: IColors;
  avatarColor?: IColors;
  customTopElementsDropdownMenu?: ReactNode;
  customBottomElementsDropdownMenu?: ReactNode;
}

export const EpAvatar: React.FC<EpAvatarProps> = ({
  avatarId,
  avatarSize = 'sm',
  avatarContent,
  avatarIconName = '',
  avatarIconImgSrc,
  avatarIconImgAlt,
  userName,
  avatarHasDropdown = false,
  dropdownId,
  dropdownDefaultList,
  customClasses = '',
  dropdownMenuPlacement = 'right',
  avatarBgColor = 'BlueLight55',
  avatarColor = 'BlueLight40',
  customTopElementsDropdownMenu,
  customBottomElementsDropdownMenu,
}) => {
  const [avatarStructure, setAvatarStructure] = useState<JSX.Element | null>(
    null,
  );
  const [avatarWithDropdown, setAvatarWithDropdown] =
    useState<JSX.Element | null>(null);

  const getUserNameInitials = (userName: string): string => {
    const splitedInitials = userName.split(' ');

    const UserNameInitials =
      splitedInitials.length > 1
        ? splitedInitials[0]
            .substring(0, 1)
            .concat(splitedInitials[splitedInitials.length - 1].substring(0, 1))
            .toUpperCase()
        : splitedInitials[0].substring(0, 1).toUpperCase();

    return UserNameInitials;
  };

  const setAvatarIconSize = (avatarSize: string): number => {
    switch (avatarSize) {
      case 'sm':
        return 16;
      case 'md':
        return 24;
      case 'lg':
        return 32;
      case '2xl':
        return 48;
      default:
        return 24;
    }
  };

  useEffect(() => {
    const avatarStructure = (
      <div
        className={`
        ep-avatar
        ep-avatar--${avatarSize}
        ${avatarHasDropdown ? 'ep-avatar--has-dropdown' : ''}`}
        slot={avatarHasDropdown ? 'dropdown-trigger-element' : ''}
        id={avatarId}
        {...(!avatarHasDropdown && {
          style: {
            backgroundColor: ColorsEnum[avatarBgColor],
            color: ColorsEnum[avatarColor],
          },
        })}
      >
        {avatarContent === 'text' ? (
          <span className="ep-avatar__username-initials">
            {getUserNameInitials(userName || '')}
          </span>
        ) : (
          <div className="ep-avatar__icon">
            {avatarIconName && (
              <EpIcon
                iconName={avatarIconName}
                iconSize={setAvatarIconSize(avatarSize)}
              />
            )}
            {avatarIconImgSrc && (
              <img
                alt={avatarIconImgAlt}
                src={avatarIconImgSrc}
                style={{
                  width: setAvatarIconSize(avatarSize),
                  height: setAvatarIconSize(avatarSize),
                }}
              />
            )}
          </div>
        )}
      </div>
    );

    const avatarWithDropdown = (
      <EpDropdown
        dropdownId={dropdownId}
        dropdownMenuPlacement={dropdownMenuPlacement}
        dropdownDefaultListItems={dropdownDefaultList}
        dropdownHasCaret={true}
        customClasses="ep-avatar__dropdown"
        customBottomElementsDropdownMenu={customBottomElementsDropdownMenu}
        dropdownTriggerElement={avatarStructure}
        customTopElementsDropdownMenu={customTopElementsDropdownMenu}
      ></EpDropdown>
    );

    setAvatarStructure(avatarStructure);
    setAvatarWithDropdown(avatarWithDropdown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    avatarId,
    avatarSize,
    avatarContent,
    avatarIconName,
    userName,
    avatarHasDropdown,
    dropdownId,
    dropdownDefaultList,
    dropdownMenuPlacement,
    avatarBgColor,
    avatarColor,
  ]);

  return (
    <div
      className={`
    ep-avatar__wrapper
    ${customClasses}`}
    >
      {avatarHasDropdown ? avatarWithDropdown : avatarStructure}
    </div>
  );
};
